import {
  checkNafath
} from "./chunk-447J5VLV.mjs";
import {
  __spreadProps,
  __spreadValues
} from "./chunk-RGHW4PYM.mjs";

// src/hooks/wbk/nafath/check.ts
import { useMutation, useQueryClient } from "@tanstack/react-query";
var useCheckNafath = ({ lang }, options) => {
  const queryClient = useQueryClient();
  return useMutation(__spreadValues({
    mutationFn: checkNafath,
    onSuccess: (user) => {
      if (user == null ? void 0 : user.accessToken) {
        queryClient.setQueryData(["user", { lang }], (oldUser) => {
          if (oldUser) {
            return __spreadProps(__spreadValues({}, oldUser || {}), {
              is_nafath_verified: true
            });
          }
          return oldUser;
        });
      }
    }
  }, options));
};

export {
  useCheckNafath
};
//# sourceMappingURL=chunk-SRBRYZ4E.mjs.map